var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-item"},[_c('OtInput',{key:_vm.selected,attrs:{"type":"radiogroup","options":_vm.options,"value":_vm.selected},on:{"input":_vm.select}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }